import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BusinessTypeDto } from '../../../../generated-model/models';
import { formatRecordedAt, resolveRecordedBy } from '../../../shared/commons/audit-display.util';

@Component({
  selector: 'app-business-type-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './business-type-modal.html'
})
export class BusinessTypeModal implements OnInit {
  @Input() businessType: BusinessTypeDto | undefined;
  @Input() viewOnly = false;
  @Input() onSave?: (payload: any, isEditMode: boolean) => Promise<boolean>;

  businessTypeForm: FormGroup;
  isEditMode = false;
  submitted = false;
  isSubmitting = false;
  recordedByDisplay = '-';
  recordedAtDisplay = '-';

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder
  ) {
    this.businessTypeForm = this.fb.group({
      id: [null],
      title: ['', [Validators.required, Validators.maxLength(255)]],
      ordering: [0, [Validators.max(32767)]],
      state: [1]
    });
  }

  ngOnInit(): void {
    if (this.businessType) {
      this.isEditMode = true;
      this.businessTypeForm.patchValue(this.businessType);
      this.recordedByDisplay = resolveRecordedBy(this.businessType);
      this.recordedAtDisplay = formatRecordedAt(this.businessType);
    } else {
      this.businessTypeForm.reset({ ordering: 0, state: 1 });
      this.recordedByDisplay = '-';
      this.recordedAtDisplay = '-';
    }

    if (this.viewOnly) {
      this.businessTypeForm.disable();
    }
  }

  save(): void {
    if (this.viewOnly) {
      return;
    }
    this.submitted = true;
    if (this.businessTypeForm.invalid) {
      return;
    }
    void this.submitAndClose(this.businessTypeForm.value);
  }

  private async submitAndClose(payload: any): Promise<void> {
    if (!this.onSave) {
      this.activeModal.close(payload);
      return;
    }

    if (this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    try {
      const isSuccess = await this.onSave(payload, this.isEditMode);
      if (isSuccess) {
        this.activeModal.close(payload);
      }
    } finally {
      this.isSubmitting = false;
    }
  }
}
